module.exports = __webpack_public_path__ + "img/marca2.13200c74.png";